import { useGetResources } from "../../hooks/useGetResources";

export const ErrorView = (): React.JSX.Element | null => {
  const resources = useGetResources();

  return (
    <div>
      {resources?.feilmelding_title}
      {resources?.feilmelding_body}
    </div>
  );
};
